import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '../Services/storage.service';

@Component({
  selector: 'app-congres-virtuel-apropos',
  templateUrl: './congres-virtuel-apropos.component.html',
  styleUrls: ['./congres-virtuel-apropos.component.scss']
})
export class CongresVirtuelAproposComponent implements OnInit {

  loginBoxShow = {display:false};

  con_user = null;

  constructor(private router:Router, private storagedata:StorageService) {
    this.con_user = storagedata.getCongresConUser()
   }

  ngOnInit() {
  }

  showLoginBox(){
    this.con_user ? this.router.navigateByUrl('/congres-virtuel/welcome') : this.loginBoxShow.display = true;
  }

  goToRegisterPage(){
    this.con_user ? alert('Vous êtes déjà connecté!') : this.router.navigateByUrl('/congres-virtuel/auth');
  }

}
